// extracted by mini-css-extract-plugin
export default {"filter":"OppListContent_filter__13C9I"};